import React from 'react';
import TextField from "@material-ui/core/TextField";

import './InputTextField.scss';

const InputTextField = props => {
  const { inputId, value, onChange, editMode, disabledMode, multiLine, maxlength } = props;

  const nullSafeValue = (value === null || value === undefined) ? '' : value;

  let formattedValue;
  if (!editMode) {
    formattedValue = (multiLine) ?
      nullSafeValue.replace(/[\n\r]/g, '<br/>') :
      nullSafeValue;
  }

  const handleChange = value => {
    value = (value === '') ? null : value;
    onChange(value);
  }

  return (
    <div className="parkchirp--input-text-field">
      {editMode ? (
        <TextField
          type="text"
          id={inputId}
          disabled={disabledMode}
          onChange={(event) => handleChange(event.target.value)}
          multiline={multiLine}
          rows={4}
          maxRows={20}
          value={nullSafeValue}
        />
      ) : (
        <span dangerouslySetInnerHTML={{ __html: formattedValue }}></span>
      )}
    </div>
  );
};

export default InputTextField;
